import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DriverManagementService, DriverManagementVerbs } from '@cordic/driver-management';
import { AppRoutes } from 'src/app/app-routes';
import { DeviceStoreService } from 'src/app/services/device-store/device-store.service';
import { RequestOptionsProviderService } from 'src/app/services/request-options-provider/request-options-provider.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';
import { mapToVoid } from 'src/app/models/utils/observable-utils';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { TimeoutError, timeout } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-account-delete-modal',
  templateUrl: './account-delete-modal.component.html',
  styleUrls: ['./account-delete-modal.component.scss']
})
export class AccountDeleteModalComponent extends SubmittableForm {
  constructor (
    translateService: TranslateService, 
    private driverManagementService: DriverManagementService, 
    private activeModal: NgbActiveModal, 
    private router: Router,
    private reqOpt: RequestOptionsProviderService,
    private deviceStore: DeviceStoreService,
    public modalService: NgbModal,
    private spinner: NgxSpinnerService,
    ) 
  {
    super(translateService)
  }

  override form = new FormGroup({
    password: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6)]
    })
  });

  dismissModal()
  {
    this.activeModal.dismiss();
  }

  async onConfirmAccDel()
  {
    this.spinner.show();

    return super.onConfirm(
      () => this.driverManagementService.post(DriverManagementVerbs.DRIVER_DELETE, { password: (this.form.value.password as string)}) 
          .pipe(mapToVoid(), timeout({ first: 60000 })),
      {
        onSuccess: async () => {
          this.dismissModal();

          this.spinner.hide();

          this.reqOpt.jwt = undefined;

          Object.keys(localStorage).forEach((key) => {
            localStorage.removeItem(key);
          });

          this.deviceStore.setIsSignedOn(false);

          this.router.navigate([AppRoutes.Login]);
        },
        onError: (error) => {
          this.dismissModal();

          this.spinner.hide();

          const modalRef = this.modalService.open(ErrorModalComponent, { backdrop: 'static', centered: true });

          // Return timeout error message if error is timeout, else give error during account deletion
          modalRef.componentInstance.errText = error instanceof TimeoutError ? this.translateService.instant("IDS_ERR_SERVER_TIMEOUT") : this.translateService.instant("IDS_ERR_ACCOUNT_DELETE");
        }
      });
  }

  shouldAllowDelete(): boolean
  {
    return this.form.invalid;
  }
}
